export default __webpack_public_path__ + "static/media/Linda_Goetze_AHV_In_Moms_We_Trust.2698b940.jpg";